import { useVisibilityStore } from '@/visibility/visibility.store';
import { goalbookUrls } from "@/util/links.js";

export default {
  beforeMount() {
    const visibilityStore = useVisibilityStore();
    if (!visibilityStore.betaVisibility) {
      // can't use router yet because home lives in vue2 app
      window.location.replace(goalbookUrls.toolkitHome)
    }
  },
};